import { render, staticRenderFns } from "./liveing.vue?vue&type=template&id=5d16b80d&"
import script from "./liveing.vue?vue&type=script&lang=js&"
export * from "./liveing.vue?vue&type=script&lang=js&"
import style0 from "./liveing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports